(function () {
  'use strict';

  var OPEN_CLASS = 'dd-option-drawer--open';
  var BACKDROP_CLASS = 'dd-option-drawer__backdrop';
  var BODY_LOCK = 'dd-drawer-open';

  function isMobile() {
    return window.innerWidth < 768;
  }

  document.addEventListener('click', function (e) {
    /* Texture-thumb zoom intercept. MUST run before the
       [data-dd-drawer-item] check below — the thumb lives inside the
       drawer item's <button>, so without this early return the click
       would fall through to selectDrawerItem() and commit the
       texture choice when the user only meant to peek.
       preventDefault + stopPropagation + return short-circuits the
       parent button's native click-to-select behaviour without
       changing its DOM (still a real <button>, still keyboard-
       accessible for the select action; only mouse/touch on the
       thumbnail rectangle gets the zoom branch). */
    var thumb = e.target.closest('[data-dd-thumb-zoom]');
    if (thumb) {
      e.preventDefault();
      e.stopPropagation();
      openTextureLightbox(thumb);
      return;
    }

    /* Clicks INSIDE the lightbox are fully handled by the dialog's
       own click listener (registered in createLightbox below). It
       calls stopPropagation() so they never reach this point — the
       check below is just a defensive secondary guard in case a
       future refactor stops calling stopPropagation. Clicking
       anywhere inside the lightbox closes it; nothing else here
       should run. */
    if (e.target.closest('dialog.dd-texture-lightbox')) {
      return;
    }

    var trigger = e.target.closest('[data-dd-custom-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      toggleDrawer(trigger);
      return;
    }

    var closeBtn = e.target.closest('[data-dd-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      var drawer = closeBtn.closest('[data-dd-option-drawer]');
      if (drawer) closeDrawer(drawer);
      return;
    }

    var item = e.target.closest('[data-dd-drawer-item]');
    if (item) {
      e.preventDefault();
      selectDrawerItem(item);
      return;
    }

    var openDrawer = document.querySelector('[data-dd-option-drawer].' + OPEN_CLASS);
    if (openDrawer && !e.target.closest('[data-dd-option-drawer]')) {
      closeDrawer(openDrawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      /* If the texture lightbox is open, let the native <dialog>
         ESC handling close it and stop here — otherwise both the
         lightbox AND the underlying drawer would close on a single
         ESC press, which would jarringly rip the user out of the
         option flow when they only meant to dismiss the preview. */
      var openLightbox = document.querySelector('dialog.dd-texture-lightbox[open]');
      if (openLightbox) return;

      var openDrawer = document.querySelector('[data-dd-option-drawer].' + OPEN_CLASS);
      if (openDrawer) {
        closeDrawer(openDrawer);
        e.preventDefault();
      }
      return;
    }

    var openDrawer = document.querySelector('[data-dd-option-drawer].' + OPEN_CLASS);
    if (!openDrawer) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var items = Array.from(openDrawer.querySelectorAll('[data-dd-drawer-item]'));
      if (!items.length) return;

      var current = openDrawer.querySelector('[data-dd-drawer-item]:focus');
      var idx = items.indexOf(current);
      if (e.key === 'ArrowDown') {
        idx = idx < items.length - 1 ? idx + 1 : 0;
      } else {
        idx = idx > 0 ? idx - 1 : items.length - 1;
      }
      items[idx].focus();
    }
  });

  function toggleDrawer(trigger) {
    var optionName = trigger.dataset.optionName;
    var pos = trigger.dataset.optionPosition;
    var container = trigger.closest('.dd-swatch-pills__custom');
    var drawer = container ? container.querySelector('[data-dd-option-drawer]') : null;
    if (!drawer) return;

    if (drawer.classList.contains(OPEN_CLASS)) {
      closeDrawer(drawer);
    } else {
      closeAllDrawers();
      openDrawer(drawer, trigger);
    }
  }

  function openDrawer(drawer, trigger) {
    drawer.removeAttribute('hidden');
    drawer.classList.add(OPEN_CLASS);
    trigger.setAttribute('aria-expanded', 'true');

    if (isMobile()) {
      var backdrop = document.createElement('div');
      backdrop.className = BACKDROP_CLASS;
      document.body.appendChild(backdrop);
      document.body.classList.add(BODY_LOCK);
    }

    var firstItem = drawer.querySelector('[data-dd-drawer-item]');
    if (firstItem) {
      requestAnimationFrame(function () { firstItem.focus(); });
    }
    var selector = drawer.closest('dd-swatch-selector');
    if (selector && typeof selector.syncDrawerPrices === 'function') {
      selector.syncDrawerPrices();
    }
  }

  function closeDrawer(drawer) {
    if (drawer.classList.contains('dd-option-drawer--closing')) return;

    var trigger = drawer.closest('.dd-swatch-pills__custom')?.querySelector('[data-dd-custom-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    drawer.classList.remove(OPEN_CLASS);
    drawer.classList.add('dd-option-drawer--closing');

    var backdrop = document.querySelector('.' + BACKDROP_CLASS);
    if (backdrop) backdrop.remove();
    document.body.classList.remove(BODY_LOCK);

    function finish() {
      drawer.removeEventListener('animationend', finish);
      drawer.classList.remove('dd-option-drawer--closing');
      drawer.setAttribute('hidden', '');
      if (trigger) trigger.focus();
    }

    drawer.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 300);
  }

  function closeAllDrawers() {
    document.querySelectorAll('[data-dd-option-drawer].' + OPEN_CLASS).forEach(function (d) {
      closeDrawer(d);
    });
  }

  function selectDrawerItem(item) {
    var drawer = item.closest('[data-dd-option-drawer]');
    var optionName = item.dataset.optionName;
    var value = item.dataset.value;
    var optionValueId = item.dataset.optionValueId;

    drawer.querySelectorAll('[data-dd-drawer-item]').forEach(function (el) {
      el.classList.remove('is--selected');
    });
    item.classList.add('is--selected');

    var trigger = drawer.closest('.dd-swatch-pills__custom')?.querySelector('[data-dd-custom-trigger]');
    if (trigger) {
      var standardPills = trigger.closest('.dd-swatch-pills')?.querySelector('.dd-swatch-pills__standard');
      if (standardPills) {
        standardPills.querySelectorAll('.dd-swatch-pill.is--selected').forEach(function (p) {
          p.classList.remove('is--selected');
          p.setAttribute('aria-pressed', 'false');
        });
      }
      trigger.classList.add('is--selected');
      var isLengthOption = /length|inch/i.test(optionName || '');
      var displayValue = value;
      if (isLengthOption) {
        displayValue = String(displayValue || '')
          .replace(/"/g, '')
          .replace(/\s*inches?\s*/gi, ' ')
          .trim();
      }
      var displayMeta = '';
      if (isLengthOption && item.dataset.gramAmount) {
        var gram = String(item.dataset.gramAmount || '')
          .replace(/"/g, '')
          .replace(/\bgrams?\b/gi, '')
          .replace(/g/gi, '')
          .trim();
        if (gram) displayMeta = ' · ' + gram + 'g';
      }
      var triggerText = trigger.childNodes[0];
      if (triggerText && triggerText.nodeType === 3) {
        triggerText.textContent = displayValue + displayMeta + ' ';
      }
      var badge = trigger.querySelector('.dd-swatch-pill__badge');
      if (badge) {
        badge.textContent = 'Custom';
        badge.classList.remove('dd-swatch-pill__badge--new');
      }
    }

    var swatchSelector = item.closest('dd-swatch-selector');
    if (swatchSelector && typeof swatchSelector.handleDrawerItemSelect === 'function') {
      swatchSelector.handleDrawerItemSelect(optionName, value, optionValueId, item);
    }

    closeDrawer(drawer);
  }

  /* ── Texture thumbnail lightbox ────────────────────────────────
     Tiny single-image lightbox for previewing texture thumbnails
     without committing the drawer item's selection. Built on the
     native <dialog> element so we get focus trap, ESC dismissal,
     and ::backdrop scrim for free — no custom focus management,
     no keydown handler, no body scroll lock needed (showModal puts
     the dialog in the top layer with inert siblings).

     Lazy-created on first click, reused thereafter. One instance
     per page lives in <body>, regardless of how many drawers /
     thumbs exist. Dimensions/styling all come from CSS so this
     module stays focused on behavior.
     ────────────────────────────────────────────────────────────── */
  var _lightboxEl = null;

  function openTextureLightbox(thumb) {
    var src = thumb.dataset.zoomSrc;
    if (!src) return;

    var dialog = _lightboxEl || (_lightboxEl = createLightbox());
    if (!dialog.isConnected) document.body.appendChild(dialog);

    var img = dialog.querySelector('.dd-texture-lightbox__img');
    if (img) {
      img.src = src;
      img.alt = thumb.dataset.zoomAlt || '';
    }

    if (typeof dialog.showModal === 'function') {
      // Defensive: showModal throws if the dialog is already open
      // (e.g. user double-taps the thumb mid-frame). Catch + replace
      // the src either way so the new texture is shown.
      try {
        if (!dialog.open) dialog.showModal();
      } catch (err) {
        if (!dialog.open) dialog.setAttribute('open', '');
      }
    } else {
      // Pre-<dialog> Safari fallback (very rare in 2026 — Safari
      // shipped <dialog> in 15.4 / March 2022). No native focus
      // trap or backdrop here, but the lightbox still appears via
      // the [open] CSS rules.
      dialog.setAttribute('open', '');
    }
  }

  function createLightbox() {
    var dialog = document.createElement('dialog');
    dialog.className = 'dd-texture-lightbox';

    var inner = document.createElement('div');
    inner.className = 'dd-texture-lightbox__inner';

    /* Close button. Has data-dd-lightbox-close so the existing
       document-level click handler routes it to dialog.close()
       without us needing a separate listener here. Real <button>
       (not nested inside another button — dialog content is the
       parent), so keyboard Tab + Enter activates natively. */
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'dd-texture-lightbox__close';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-dd-lightbox-close', '');
    close.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<line x1="18" y1="6" x2="6" y2="18"></line>' +
        '<line x1="6" y1="6" x2="18" y2="18"></line>' +
      '</svg>';

    var img = document.createElement('img');
    img.className = 'dd-texture-lightbox__img';
    img.alt = '';
    img.decoding = 'async';

    inner.appendChild(close);
    inner.appendChild(img);
    dialog.appendChild(inner);

    /* Click anywhere inside the lightbox closes it. The image has
       cursor:zoom-out via CSS to telegraph this, the close button
       is the explicit affordance for keyboard users, and tapping
       the dark backdrop area is the natural mobile gesture.
       stopPropagation is critical: without it the click bubbles
       to the document-level click listener above, which would
       fall through to the "click outside an open drawer closes
       it" branch and rip the underlying drawer shut while the
       user was just dismissing the preview. */
    dialog.addEventListener('click', function (e) {
      e.stopPropagation();
      dialog.close();
    });

    return dialog;
  }
})();
